import React from "react";
import { Button, Modal } from "antd";

import TextInfo from "../../../../components/common/TextInfo/TextInfo";

const EditCapitalCashDialog = ({
  visible,
  handleCancel,
  handleSave,
  actionButtonText,
  title,
  handleChange,
  errors,
  minValue,
  maxValue,
}) => {
  const handleInputChange = (values, source) => {
    const field = source?.event?.target?.name;
    handleChange(field, values.value);
  };

  return (
    <Modal
      className="modal-form"
      title={title}
      visible={visible}
      onCancel={handleCancel}
      width={"30%"}
      centered
      footer={[
        <Button
          key="back"
          onClick={handleCancel}
          className="btn-modal btn-default"
        >
          Kembali
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSave}
          className="btn-modal"
        >
          {actionButtonText}
        </Button>,
      ]}
    >
      <div className="modal-form-content">
        <TextInfo
          title="Minimal"
          value={minValue}
          isInputNumber
          type={"input"}
          id={"min-amount"}
          handleChange={handleInputChange}
          error={errors?.minAmount}
          placeholder={"Masukkan Jumlah Minimal"}
          isForm
        />
        <TextInfo
          title="Maksimal"
          value={maxValue}
          isInputNumber
          type={"input"}
          id={"max-amount"}
          handleChange={handleInputChange}
          error={errors?.maxAmount}
          placeholder={"Masukkan Jumlah Maksimal"}
          isForm
        />
      </div>
    </Modal>
  );
};

export default EditCapitalCashDialog;
